/**
 * Map API / network errors to user-friendly messages (never show ORM internals).
 */
export function getFriendlyErrorMessage(error, fallback = 'Something went wrong. Please try again.') {
  const raw =
    error?.friendlyMessage
    || error?.response?.data?.error
    || error?.message
    || '';
  const lower = String(raw).toLowerCase();

  if (
    lower.includes('foreign key constraint')
    || lower.includes('p2003')
    || lower.includes('still referenced')
  ) {
    return 'Cannot delete this user because related records still reference their account. Try deactivating instead.';
  }

  if (
    lower.includes('invalid `prisma')
    || lower.includes('prisma.')
    || lower.includes('does not exist in the current database')
  ) {
    return 'The service is temporarily unavailable. Please try again shortly or contact support if this continues.';
  }

  if (!error?.response && (lower.includes('network error') || lower.includes('timeout'))) {
    return 'Unable to reach the server. Please check your connection and try again.';
  }

  if (lower.includes('invalid credentials') || lower.includes('invalid email or password')) {
    return 'Invalid email or password.';
  }

  if (lower.includes('account is deactivated')) {
    return 'Your account has been deactivated. Contact your administrator.';
  }

  if (/`/.test(raw) || /invocation/i.test(raw)) {
    return fallback;
  }

  if (raw && raw.length <= 160 && !lower.includes('prisma')) {
    return raw;
  }

  return fallback;
}
